var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91016 4.75L8.86328 1.82422C9.02734 1.66016 9.02734 1.35938 8.86328 1.19531L8.17969 0.511719C8.01562 0.347656 7.71484 0.347656 7.55078 0.511719L4.625 3.46484L1.67188 0.511719C1.50781 0.347656 1.20703 0.347656 1.04297 0.511719L0.359375 1.19531C0.195312 1.35938 0.195312 1.66016 0.359375 1.82422L3.3125 4.75L0.359375 7.70312C0.195312 7.86719 0.195312 8.16797 0.359375 8.33203L1.04297 9.01562C1.20703 9.17969 1.50781 9.17969 1.67188 9.01562L4.625 6.0625L7.55078 9.01562C7.71484 9.17969 8.01562 9.17969 8.17969 9.01562L8.86328 8.33203C9.02734 8.16797 9.02734 7.86719 8.86328 7.70312L5.91016 4.75Z",
    fill: "#E25047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelRed);
export default __webpack_public_path__ + "static/media/Cancel_red.5d083e101b6ae71f30d75ceda1f91d03.svg";
export { ForwardRef as ReactComponent };